import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';

@Component({
    selector: 'app-inventory-queue-overview',
    templateUrl: './inventory-queue-overview.component.html',
    styleUrls: ['./inventory-queue-overview.component.scss'],
    standalone: false
})
export class InventoryQueueOverviewComponent implements OnInit {
    processedLines: any[] = [];
    unProcessedLines: any[] = [];
    poisonLines: any[] = [];
    processing = false;

    @ViewChild('processedLinesGrid') processedLinesGrid: DxDataGridComponent;
    @ViewChild('unProcessedLinesGrid') unProcessedLinesGrid: DxDataGridComponent;
    @ViewChild('poisonLinesGrid') poisonLinesGrid: DxDataGridComponent;

    constructor(private utility: UtilityService, private uow: GenesisUnitOfWork, public auth: AuthService, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.getData();
    }
    async getData() {
        await this.getUnprocessedLines();
        await this.getPoisonLines();
        await this.getProcessedLines();
    }

    async getUnprocessedLines() {
        this.unProcessedLines = await this.uow.getUnProcessedInventoryOrderLineDetails();
    }

    async getPoisonLines() {
        this.poisonLines = await this.uow.getPoisonedInventoryOrderLineDetails();
    }

    async getProcessedLines() {
        this.processedLines = await this.uow.getPreviousProcessQueueMessages();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                template: 'toolbarTextBefore',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }
}
